import axios from "axios";

const BASE_URL = "https://6fau5cp3m1.execute-api.ap-south-1.amazonaws.com";

// 🔐 Auth & Onboarding
export const requestOtp = (mobile) =>
  axios.post(`${BASE_URL}/request-otp`, { mobile });

export const verifyOtp = (mobile, otp, name, identityPublicKey) =>
  axios.post(`${BASE_URL}/verify-otp`, {
    mobile,
    otp,
    name,
    identityPublicKey,
  });

export const checkUserExists = (mobile) =>
  axios.post(`${BASE_URL}/check-user`, { mobile });

// 👥 User Info
// Should return name, mobile, online status
export const getUsers = () => axios.get(`${BASE_URL}/users`);

export const getPublicKey = (mobile) => axios.get(`${BASE_URL}/public-key/${mobile}`);

// 💬 Messaging
export const getMessages = (
  senderMobile,
  recipientMobile,
  beforeTimestamp,
  limit
) => {
  const params = { sender: senderMobile, recipient: recipientMobile };
  if (beforeTimestamp) params.before = beforeTimestamp;
  if (limit) params.limit = limit;
  return axios.get(`${BASE_URL}/messages`, { params });
};

// 👤 Profile
export const updateProfile = (name, avatar) => {
  const token = localStorage.getItem("token");
  return axios.post(
    `${BASE_URL}/update-profile`,
    { name, avatar },
    {
      headers: { Authorization: token },
    }
  );
};

// 📎 Media Upload
export const getUploadUrl = (fileName, fileType, fileSize) => {
  const token = localStorage.getItem("token");
  return axios.post(
    `${BASE_URL}/upload-media`,
    { fileName, fileType, fileSize },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const getDownloadUrl = (s3Key) => {
  const token = localStorage.getItem("token");
  return axios.post(
    `${BASE_URL}/download-media`,
    { s3Key },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const uploadToS3 = (uploadUrl, file) => {
  return axios.put(uploadUrl, file, {
    headers: {
      "Content-Type": file.type,
    },
  });
};
